import { render } from "./SearchVariables.vue?vue&type=template&id=4fb5f07c&scoped=true"
import script from "./SearchVariables.vue?vue&type=script&lang=js"
export * from "./SearchVariables.vue?vue&type=script&lang=js"

import "./SearchVariables.vue?vue&type=style&index=0&id=4fb5f07c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb5f07c"]])

export default __exports__